module.exports = __webpack_public_path__ + "static/blog-d-1-1-d92da4a0e680ab44b22e24916cda595f.jpg";